import { makeStyles } from "@material-ui/core/styles";

export const useErrorPageStyles = makeStyles(() => ({
  container: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "#151921"
  },

  blueCircle: {
    position: "fixed",
    bottom: -150,
    left: -110,
    width: 300,
    objectFit: "cover",
    objectPosition: "center",
    opacity: 0.7
  },

  greenRectangle: {
    position: "fixed",
    top: 0,
    right: 0,
    width: 200,
    objectFit: "cover",
    objectPosition: "center"
  },

  header: {
    padding: 25,
    height: 85
  },

  logo: {
    height: 35
  },

  content: {
    height: "calc(100vh - 85px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    color: "#fff",
    maxWidth: 356,
    margin: "0 auto"
  },

  icon: {
    marginBottom: 25
  },

  title: {
    marginBottom: 25
  },

  footer: {
    marginTop: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  footerImg: {
    height: 18,
    margin: "0 15px",
    objectFit: "contain",
    objectPosition: "center"
  }
}));
